import { render, staticRenderFns } from "./ChangeVerificationModal.vue?vue&type=template&id=583304dc&scoped=true&"
import script from "./ChangeVerificationModal.vue?vue&type=script&lang=js&"
export * from "./ChangeVerificationModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeVerificationModal.vue?vue&type=style&index=0&id=583304dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583304dc",
  null
  
)

export default component.exports